export default __webpack_public_path__ + "static/media/CaduceusLogoRed.ff747b47.png";